export default {
    pageId: 0,
    moduleId: 0,
    setMenuPageId: 0, //Poderá ser diferente da atual, pois poderá ser uma página interna
    name: "",
    path: "",
    pageTitle: "",
    singularTitle: "",
}